module.exports = __webpack_public_path__ + "site/img/sd-Hat.31885f3b.png";